import type { TMessages } from '@/types/TMessages'

export const messages = { articlesHeader: 'Статьи', loadMoreBtn: 'Показать еще' } satisfies TMessages
